import React from "react";

const Stat_Prediction_And_Explanation = () => {
  return (
    <div>
      <h1>Stat Prediction & Explanation</h1>
    </div>
  );
};

export default Stat_Prediction_And_Explanation;
